import React from 'react';

export default class Detail extends React.Component {
  componentDidMount(){
    const doc = new DOMParser().parseFromString(this.props.data, 'text/html');
    const body = doc.getElementById('loader');
    document.getElementById("box-iframe").appendChild(body);
  }
  render(){

    return(
      <div id='box-iframe'>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/ebook/Detail.js